const CMS_BASE_URL = "https://api.dev.auxo.dk/public";

// Helper for image URLs
export function getOptimizedImageUrl(url, { width = 800, quality = 80, format = "auto" } = {}) {
  if (!url || typeof url !== "string") return "";
  // Direct assets URL is fast, reliable, and avoids cross-origin header blocking in local testing
  return url;
}

export async function fetchCmsCollection(collectionName, params = {}) {
  try {
    const query = new URLSearchParams();
    if (params.sort) query.set("sort", params.sort);
    if (params.order) query.set("order", params.order);
    if (params.limit) query.set("limit", params.limit.toString());
    if (params.offset) query.set("offset", params.offset.toString());
    if (params.term) {
      if (Array.isArray(params.term)) {
        params.term.forEach((t) => query.append("term", t));
      } else {
        query.append("term", params.term);
      }
    }

    const queryString = query.toString() ? `?${query.toString()}` : "";
    const response = await fetch(`${CMS_BASE_URL}/v2/content/${collectionName}${queryString}`, {
      headers: {
        Accept: "application/json"
      }
    });

    if (!response.ok) {
      const v1Res = await fetch(`${CMS_BASE_URL}/content/${collectionName}`);
      if (v1Res.ok) {
        const items = await v1Res.json();
        return { items: Array.isArray(items) ? items : [], total: items.length || 0 };
      }
      return { items: [], total: 0 };
    }

    const data = await response.json();
    return {
      items: Array.isArray(data.items) ? data.items : [],
      total: data.total || (data.items ? data.items.length : 0)
    };
  } catch (error) {
    console.warn(`CMS fetch failed for ${collectionName}:`, error);
    return { items: [], total: 0 };
  }
}
